import { useState, useEffect, useCallback } from 'react';

function useLongPress(callback = () => {}, timeout = 300) {
  const [startLongPress, setStartLongPress] = useState(false);

  useEffect(() => {
    let timerId;
    if (startLongPress) {
      timerId = setTimeout(callback, timeout);
    }
    return () => {
      if (timerId) {
        clearTimeout(timerId);
      }
    };
  }, [startLongPress, callback, timeout]);

  const start = useCallback(() => {
    setStartLongPress(true);
  }, []);
  const stop = useCallback(() => {
    setStartLongPress(false);
  }, []);

  return {
    onMouseDown: start,
    onMouseUp: stop,
    onMouseLeave: stop,
    onTouchStart: start,
    onTouchEnd: stop,
  };
}
export default useLongPress;
